/* Points sous une liste qui défile à l'horizontale (avis sur téléphone) : un point par carte, le point
   noir suit la carte visible, toucher un point y amène. Remplacent la barre de défilement du navigateur.
   Le conteneur .nky-points suit directement la liste ; il reste caché tant que la liste ne défile pas
   (grille sur ordinateur, une seule carte). Chargé par chaque liste : ne s'installe qu'une fois. */
(function () {
  if (window.nkyPoints) return;
  window.nkyPoints = true;

  var doux = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function brancher(points) {
    var liste = points.previousElementSibling;
    if (!liste || points.dataset.nkyPret) return;
    points.dataset.nkyPret = '1';
    var etiquette = points.dataset.label || '__n__';
    var cartes = [];
    var boutons = [];

    function construire() {
      cartes = Array.prototype.filter.call(liste.children, function (c) { return c.offsetWidth > 0; });
      points.textContent = '';
      boutons = cartes.map(function (carte, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'nky-points__point';
        b.setAttribute('aria-label', etiquette.replace('__n__', i + 1));
        b.addEventListener('click', function () {
          liste.scrollTo({ left: carte.offsetLeft - cartes[0].offsetLeft, behavior: doux ? 'smooth' : 'auto' });
        });
        points.appendChild(b);
        return b;
      });
      suivre();
    }

    function suivre() {
      var defile = liste.scrollWidth > liste.clientWidth + 2;
      points.hidden = !defile || cartes.length < 2;
      if (points.hidden) return;
      var actif;
      if (liste.scrollLeft + liste.clientWidth >= liste.scrollWidth - 4) {
        actif = cartes.length - 1; // la dernière carte ne peut pas s'aligner à gauche : fin de liste = dernier point
      } else {
        var pas = cartes[1].offsetLeft - cartes[0].offsetLeft || 1;
        actif = Math.round(liste.scrollLeft / pas);
      }
      boutons.forEach(function (b, i) {
        b.classList.toggle('is-on', i === actif);
        if (i === actif) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }

    // calcul direct (quelques cartes) : pas de requestAnimationFrame, gelé quand l'onglet est caché
    liste.addEventListener('scroll', suivre, { passive: true });
    window.addEventListener('resize', construire);
    construire();
  }

  function tout() {
    document.querySelectorAll('[data-nky-points]').forEach(brancher);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();
  // éditeur de thème : la section est redessinée quand on ajoute, retire ou déplace un avis
  document.addEventListener('shopify:section:load', tout);
})();
